import React from 'react'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import CampaignGoalOptions from './Options'

export const GoalCampaign: React.FC = () => (
  <>
    <Alert variant="informational">
      {t('rm:objectiveBased.strategy.info')}
    </Alert>

    <CampaignGoalOptions />
  </>
)

export default React.memo(GoalCampaign)
